import { Component, input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "themed-section",
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./themed-section.html",
})
export class ThemedSection {
  bgClass = input.required<string>();
}
